<template>
    <div>
        <base-button-icon
            @click="openShareModal"
            icon-name="share"
            :button-text="$t('SHARE')"
        />

        <share-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            :modal-image="modalImage"
        />
    </div>
</template>

<script>
    import allStores from '../../stores/all';

    import BaseButtonIcon from './BaseButtonIcon.vue';
    import ShareModal from '../ShareModal.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonIcon,
            ShareModal,
        },

        data() {
            return {
                showModal: false,
                modalImage: '',
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },
        },

        watch: {
            showModal(value) {
                if (value) {
                    this.setShowGroupOverlay(false);
                }
            },
        },

        methods: {
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },

            openShareModal() {
                this.takeSnapshot();

                this.showModal = true;
            },

            takeSnapshot() {
                this.emitter.$emit('snapshot', {
                    controllerId: this.viewController.id,
                    view: 'Side',
                    done: (data) => {
                        this.modalImage = data;
                    },
                });
            },
        },
    };
</script>
